// extracted by mini-css-extract-plugin
export default {"modal__container":"modal-window_modal__container__pHJrK"};